"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuContent = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("../context");
var content_1 = require("../styled/content");
var MenuContent = function (_a) {
    var _b;
    var __UIScope = _a.__UIScope, children = _a.children, className = _a.className, testID = _a["data-testid"], size = _a.size, visibleOptionsCount = _a.visibleOptionsCount;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'MenuContent',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    // Position
    var _c = tslib_1.__read((0, react_1.useState)(), 2), rootComponent = _c[0], setRootComponent = _c[1];
    var rootRef = (0, react_1.useCallback)(function (node) {
        if (node !== null) {
            setRootComponent(node);
        }
    }, []);
    var contentPosition = (_b = rootComponent === null || rootComponent === void 0 ? void 0 : rootComponent.getBoundingClientRect().right) !== null && _b !== void 0 ? _b : 0;
    var isReverse = size && content_1.Sizes[size] - contentPosition > 0;
    // Visibility
    var contentRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useContext)(context_1.MenuContext), isShowing = _d.isShowing, onClose = _d.onClose, isDismissible = _d.isDismissible, hasTriggerElement = _d.hasTriggerElement, isInverse = _d.isInverse, pattern = _d.pattern;
    (0, ui_helper_hooks_1.useOnClickOutside)(contentRef, onClose, {
        isActive: isDismissible && isShowing,
    });
    (0, ui_helper_hooks_1.useOnKeyPress)('Escape', onClose);
    if (!isShowing) {
        return null;
    }
    return (react_1.default.createElement(content_1.ContentWrapper, { ref: rootRef },
        react_1.default.createElement(content_1.Content, { className: rootClasses, "data-testid": testID, level: isInverse ? 'high' : 'base', ref: contentRef, size: size, isDouble: pattern === 'double', hasTriggerElement: hasTriggerElement, isReverse: isReverse, isInverse: isInverse, visibleOptionsCount: visibleOptionsCount }, children)));
};
var MenuContentWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuContent);
exports.MenuContent = MenuContentWithSpace;
//# sourceMappingURL=menu-content.js.map